import { createFileRoute, Link } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { buttonStyles } from "@/components/ui/button";

export const Route = createFileRoute("/help/rules")({
  component: RulesHelp,
});

function RulesHelp() {
  return (
    <section className="mx-auto mt-6 max-w-2xl space-y-5 px-1 pb-12">
      <header className="px-1">
        <h1 className="font-display text-3xl text-locomotive-900">
          How to play
        </h1>
        <p className="font-mono text-xs text-muted-foreground">
          The short version. mextrain scores; you and the boys handle the
          tiles.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Setup</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="font-mono text-sm space-y-2 text-foreground">
            <li>Each player draws <strong>12 tiles</strong> from the boneyard.</li>
            <li>The round's <strong>engine</strong> — typically the highest double a player holds — sits face-up in the center. Tables vary on how the engine is chosen each round; agree at the table.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>First turn</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="font-mono text-sm space-y-2 text-foreground">
            <li>Whoever holds the engine double places it first and starts their personal train.</li>
            <li>If nobody has it, the first player draws one tile, then play moves clockwise.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Your turn</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="font-mono text-sm space-y-2 text-foreground">
            <li>Play one tile end-to-end matching the open end of any train you're allowed on.</li>
            <li>You can always play on <strong>your own train</strong> and the <strong>Mexican Train</strong> (a public train anyone may extend).</li>
            <li>Other players' trains are private unless they're <strong>marked public</strong> with a marker.</li>
            <li>If you can't play, draw one tile from the boneyard. If you still can't, place a marker on your own train.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Doubles</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="font-mono text-sm space-y-2 text-foreground">
            <li>Doubles sit perpendicular to the train.</li>
            <li>The player who lays a double <strong>plays again immediately</strong> to <strong>cover</strong> it before normal turn order resumes.</li>
            <li>If they can't cover from their own hand, they draw one tile. If that doesn't cover either, the duty passes to the next player, and around the table until someone covers.</li>
            <li>While a double is uncovered, <strong>no other train moves</strong> — the whole table is on hold.</li>
            <li>If nobody can cover (the matching tiles are simply gone), normal play resumes.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>End of round</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="font-mono text-sm space-y-2 text-foreground">
            <li>Round ends when a player empties their hand, or the boneyard is empty and nobody can play.</li>
            <li>Each remaining player scores the sum of pips on tiles still in their hand.</li>
            <li>The player who emptied scores <strong>0</strong>.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Game end</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="font-mono text-sm text-foreground">
            Lowest cumulative score after all rounds wins.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>House rule (optional)</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="font-mono text-sm text-foreground">
            Double-blank can count as <strong>50 pips</strong> instead of 0. The host picks at game start.
          </p>
        </CardContent>
      </Card>

      <div className="flex justify-center pt-2">
        <Link to="/" className={buttonStyles("ghost", "default")}>
          Back to the station
        </Link>
      </div>
    </section>
  );
}
